export const dispatchPageView = (currentPage, pageDetail, selector) => {


    try {
        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.page === 'undefined' || vzdl.page === null)
            && !(typeof vzdl.page.name === 'undefined' || vzdl.page.name === null)) {
            vzdl.page.name = currentPage;
            vzdl.page.flow = "intl itp";
            vzdl.page.throttle = "nsa 1.0";
            window.coreData = window.coreData || [];
            window.coreData.push({
                task: "emit",
                event: "pageView",
                params: {
                    data: {
                        page: {
                            detail: typeof pageDetail !== "undefined" && pageDetail,
                        }
                    }

                }
            });
            window.coreData = window.coreData || [];
            window.coreData.push({
                task: "emit",
                event: "openView",
                params: {
                    selector: selector, 
                    name: typeof pageDetail !== "undefined" && pageDetail,
                    trackAs: "none"
                }
            });
        }
        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.page === 'undefined' || vzdl.page === null)
            && !(typeof vzdl.page.detail === 'undefined' || vzdl.page.detail === null)) {
            vzdl.page.detail = "";
        }
    }
    catch (ex) { }
}

// export const dispatchConfirmationPageView = (currentPage) => {
//     try {
//         if (!(typeof vzdl === 'undefined' || vzdl === null)
//             && vzdl && !(typeof vzdl.page === 'undefined' || vzdl.page === null)
//             && !(typeof vzdl.page.name === 'undefined' || vzdl.page.name === null)) {
//             vzdl.page.name = currentPage;
//             vzdl.page.throttle = "nsa 1.0";
//         }
//         if (!(typeof window.VZTAG_IS_READY === 'undefined' || window.VZTAG_IS_READY === null) && window.VZTAG_IS_READY) {
//             vztag.api.dispatch("pageView", {});
//         } else {
//             document.addEventListener("vztagReady", function () {
//                 window.vztag.api.dispatch("pageView", {});
//             });
//         }
//     }
//     catch (ex) { }
// }

export const dispatchVzdlEvent = (eventName) => {
    try {
        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.event === 'undefined' || vzdl.event === null)
            && !(typeof vzdl.event.value === 'undefined' || vzdl.event.value === null)) {
            vzdl.event.value = eventName;
        }
    }
    catch (ex) { }
}
export const setModelTagging = (title, id, opened) => {

    if (opened) {
        setOpenModel(title, id);
        setModalName(title);
    }
    else {
        setCloseModel(title, id);
        setModalName("");
    }
}
export const setOpenModel = (title, elementId) => {
    try {
        if (window.vztag) {
            window.coreData = window.coreData || [];
            window.coreData.push({
                task: "emit",
                event: "openView",
                params: {
                    selector: elementId,
                    name: title
                }
            });
        }
    } catch (ex) { }
}
export const setCloseModel = (title, elementId) => {
    try {
        if (window.vztag) {
            window.coreData = window.coreData || [];
            window.coreData.push({
                task: "emit",
                event: "closeView",
                params: {
                    selector: elementId,
                    name: title
                }
            });
        }
    } catch (ex) { }
}
export const setModalName = (currentPage) => {

    try {
        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.page === 'undefined' || vzdl.page === null)
            && !(typeof vzdl.page.detail === 'undefined' || vzdl.page.detail === null)) {
            vzdl.page.detail = currentPage;
        }
    }
    catch (ex) { }
}


export const dispatchError = (errMsgDisplayed) => {
    try {
        if (window.vztag) {

            window.coreData = window.coreData || [];
            window.coreData.push({
                task: "emit",
                event: "error",
                params: {
                    message: errMsgDisplayed
                }
            });
        }

    } catch (ex) { }
}



export const dispatchNotifyEvent = (name, errorCode, message) => {
    try {
        window.coreData = window.coreData || [];
        window.coreData.push({
            task: "emit",
            event: "notify",
            params: {
                name: name,
                message: message,
                error: errorCode == "99" ? true : false,
            }
        });
    } catch (ex) { }
}
export const dispatchProductTracker = (name, event, products) => {
    try {
        window.coreData = window.coreData || [];
        window.coreData.push({
            task: "emit",
            event: "productTracker",
            params: {
                name: name,
                events: event, // comma delimit multiple events
                products: products
            }
        });
    } catch (ex) { }
}

const checkUpdatePlanStatus = (deviceInfo, confirmedPlanData, failedUpdateCartData) => {

    if (confirmedPlanData.some(plan => (plan.mtn === deviceInfo?.mtn))) {
        return "Updated"
    } else if (failedUpdateCartData.some(plan => (plan.mtn === deviceInfo?.mtn))) {
        return "Error"
    } else {
        return ""
    }
}
const getDeviceAndPlansImpression = (deviceInfoData, confirmedPlanData, failedUpdateCartData) => {
    const deviceDetails = [];
    deviceInfoData.map((device) => {
        deviceDetails.push({
            "type": device.role,
            "status": checkUpdatePlanStatus(device, confirmedPlanData, failedUpdateCartData)
        })
    })
    const combinedDevices = deviceDetails.map((d) => `${d.type}|${d.status}`).join('|^');
    return {
        "impression": `||||||${combinedDevices}`,
        "updatedLines": deviceDetails.filter((d) => d.status === "Updated"),
        "failedLines": deviceDetails.filter((d) => d.status === "Error"),
    } 


}

const getPlanChangesDetails = (confirmedPlanData) => {
    return confirmedPlanData && confirmedPlanData.map((line, id) => {
        return line?.featuresCart.map((d) => `${d.currentPlanName ? d.currentPlanName : ""}|${d.newPlanName ? d.newPlanName : ""}`).join('^')
    }).join('^')
}
export const dispatchDeviceAndPlansImpression = (deviceInfoData, confirmedPlanData, failedUpdateCartData) => {
    try {
        const lineDetails = getDeviceAndPlansImpression(deviceInfoData, confirmedPlanData, failedUpdateCartData);
        window.coreData = window.coreData || [];
        window.coreData.push({
            task: "emit",
            event: "impression",
            params: {
                list: lineDetails.impression,
            }
        });

        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.txn === 'undefined' || vzdl.txn === null)
            && !(typeof vzdl.txn.planChanges === 'undefined' || vzdl.txn.planChanges === null)) {
            vzdl.txn.planChanges = getPlanChangesDetails(confirmedPlanData);
        }
    } catch (ex) { }
}

export const setConfimedPlanDetail = (confirmationData,selector) => {

    let successProducts = [];
    let failedProducts = [];
    let deviceDetails = confirmationData?.deviceDetails;
    if (!(typeof vzdl === 'undefined' || vzdl === null)
        && vzdl && !(typeof vzdl.txn === 'undefined' || vzdl.txn === null)
        && !(typeof vzdl.txn.product === 'undefined' || vzdl.txn.product === null)
        && !(typeof vzdl.txn.product.current === 'undefined' || vzdl.txn.product.current === null)) {
        vzdl.txn.id = confirmationData?.orderNumber ?? "";
        vzdl.txn.autoPay = '';
        vzdl.txn.orderType = 'intl';
        vzdl.txn.offer = '';
        vzdl.txn.discountId = '';
        vzdl.txn.paymentType = "";
        vzdl.txn.recurringCharges = "";
        vzdl.txn.discount = "";
        vzdl.txn.product.current = [];
       


        deviceDetails && deviceDetails.map((line, id) => {

            line?.currentPlanDetails.map((currentPlan) => {
                let cost = currentPlan.planCost && currentPlan.planCost.split('/') ? currentPlan.planCost.split('/')[0] : currentPlan.planCost;
                if (currentPlan.planUpdated) {
                    successProducts.push({
                        "name": currentPlan?.planName,
                        "id": currentPlan?.planId,
                        "merchCat": "", //merchandising category of the product - where did you see the product (eg: product grid wall pge/ hp /banner etc)
                        "category": "PLAN",
                        "offer": "",
                        "discount": "",
                        "qty": "1",
                        "recurringPrice": cost,
                        "nonRecurringPrice": "",
                        "line": line?.mtnHashCode,
                        "sku": "",
                        "contractType": "", //Contract Type
                        "shippingCharge": "", //Shipping charge in dollar
                        "shippingType": "", //Eg : Standard Shipping/pick up from store etc
                        "shared": "", //(Y/N)
                        "propId": "",
                        "path": "",
                        "group": id + 1,
                        "action": "",
                        "orderType": "INTL",
                    })
                } else {
                    failedProducts.push({
                        "name": currentPlan?.planName,
                        "id": currentPlan?.planId,
                        "merchCat": "", //merchandising category of the product - where did you see the product (eg: product grid wall pge/ hp /banner etc)
                        "category": "PLAN",
                        "offer": "",
                        "discount": "",
                        "qty": "1",
                        "recurringPrice": cost,
                        "nonRecurringPrice": "",
                        "line": line?.mtnHashCode,
                        "sku": "",
                        "contractType": "", //Contract Type
                        "shippingCharge": "", //Shipping charge in dollar
                        "shippingType": "", //Eg : Standard Shipping/pick up from store etc
                        "shared": "", //(Y/N)
                        "propId": "",
                        "path": "",
                        "group": id + 1,
                        "action": "",
                        "orderType": "INTL",
                    })
                }

            })
        })
        vzdl.txn.product.current = successProducts;
    }
    if (!(typeof vzdl === 'undefined' || vzdl === null)
        && vzdl && !(typeof vzdl.txn === 'undefined' || vzdl.txn === null)
        && !(typeof vzdl.txn.numberOfLines === 'undefined' || vzdl.txn.numberOfLines === null)) {
        //No of lines updated
        vzdl.txn.numberOfLines = deviceDetails.filter((line) => line.planUpdated).length;
    }
    
    dispatchVzdlEvent("event116,event171,event113,purchase,event84,event9")

    dispatchPageView('ITP_confirmation', "confirmation",selector);
    if (successProducts.length > 0) {
        dispatchProductTracker("ITP Product success", "event407", successProducts);
    }
    if (failedProducts.length > 0) {
        dispatchProductTracker("ITP Product failure", "event408", failedProducts);
    }


}
const combinedValues = (currentPlanDetails, key) => {
    if (key === "planCost") {
        return currentPlanDetails?.map(plan => {
            let cost = plan.planCost && plan.planCost.split('/') ? plan.planCost.split('/')[0] : plan.planCost;
            return cost;
        }).join('|');
    } else {
        return currentPlanDetails?.map(plan => plan[key]).join('|');
    }

}
export const setCurrentPlanDetails = (deviceData,selector) => {

    try {
        if (!(typeof vzdl === 'undefined' || vzdl === null)
            && vzdl && !(typeof vzdl.user === 'undefined' || vzdl.user === null)
            && !(typeof vzdl.user.numberOfLines === 'undefined' || vzdl.user.numberOfLines === null))
            {
                //No of lines on account
                vzdl.user.numberOfLines = deviceData.length
            }
        // if (!(typeof vzdl === 'undefined' || vzdl === null)
        //     && vzdl && !(typeof vzdl.txn === 'undefined' || vzdl.txn === null)
        //     && !(typeof vzdl.txn.product === 'undefined' || vzdl.txn.product === null)
        //     && !(typeof vzdl.txn.product.owns === 'undefined' || vzdl.txn.product.owns === null)) {
        //     let planList = [];
        //     vzdl.txn.product.owns = [];

        //     plansData && plansData.map((plan, id) => {
        //         //let cost = plan.planCost && plan.planCost.split('/') ? plan.planCost.split('/')[0] : plan.planCost;
        //         // let planType = plan.planType === "ALP" ? "Y" : "N";// Y for shared plans and N for line level plans
        //         plan?.currentPlanDetails.map((currentPlan) => {
        //             let cost = currentPlan.planCost && currentPlan.planCost.split('/') ? currentPlan.planCost.split('/')[0] : currentPlan.planCost;
        //             vzdl.txn.product.owns.push(
        //                 {
        //                     "name": currentPlan?.planName,
        //                     "id": currentPlan?.planId,
        //                     "category": "Plan",
        //                     "recurringPrice": cost,
        //                     "shared": "-"
        //                 }
        //             )
        //         })
        //         if (plan?.currentPlanDetails.length === 0) {
        //             vzdl.txn.product.owns.push(
        //                 {
        //                     "name": "-",
        //                     "id": "-",
        //                     "category": "Plan",
        //                     "recurringPrice": "-",
        //                     "shared": "-"
        //                 }
        //             )
        //         }
        //     })
        // }
        dispatchVzdlEvent("event117");
        dispatchPageView('ITP_DeviceandplansSelection', 'review itp plan',selector);
       

    }
    catch (ex) { console.log("error", ex) }
}
